<template>
  <v-dialog
    max-width="600px"
    v-model="sceneSelectorDialog">
    <ScenePicker
      v-if="sceneSelectorDialog"
      v-on:selected="sceneSelected"
      v-on:close="sceneSelectorDialog = false" />
  </v-dialog>

  <div
    v-for="(svar, index) in vars"
    :key="index">
    <div
      class="mb-2"
      v-if="svar.type === 'scene_select'"
      style="display: flex">
      <v-btn
        v-if="vars[index]['type'] === 'scene_select'"
        :color="vars[index]['value'] ? 'primary' : textBoxBackground"
        @click="sceneSelectorDialog = true"
        variant="tonal"
        small
        block>
        Select Scene
      </v-btn>
    </div>
    <v-checkbox
      class="mb-2"
      v-else-if="svar.type === 'bool'"
      v-model="vars[index]['value']"
      :label="vars[index]['name']"
      :hint="vars[index]['hint']"></v-checkbox>
    <v-text-field
      class="mb-2"
      v-else-if="svar.type === 'text'"
      v-model="vars[index]['value']"
      :label="vars[index]['name']"
      :hint="vars[index]['hint']"></v-text-field>
    <v-select
      class="mb-2"
      v-else-if="svar.type === 'enum'"
      v-model="vars[index]['value']"
      :items="vars[index]['options']"
      :label="vars[index]['name']"
      :hint="vars[index]['hint']"></v-select>
    <v-autocomplete
      class="mb-2"
      v-else-if="svar.type === 'frames'"
      v-model="vars[index]['value']"
      :items="[1, 2, 3, 4, 5, 6]"
      multiple
      :label="vars[index]['name']"
      :hint="vars[index]['hint']"></v-autocomplete>
    <v-autocomplete
      class="mb-2"
      v-else-if="svar.type === 'autocomplete'"
      v-model="vars[index]['value']"
      :items="channelsWithNames()"
      item-title="name"
      item-value="did"
      multiple
      :label="vars[index]['name']"
      :hint="vars[index]['hint']"></v-autocomplete>
    <AssetsTemplatesDropdown
      class="mb-3"
      v-else-if="svar.type === 'preset_select'"
      mode="templates"
      :item="vars[index]['value']"></AssetsTemplatesDropdown>
    <AssetsTemplatesDropdown
      class="mb-3"
      v-else-if="svar.type === 'asset_select'"
      mode="assets"
      :item="vars[index]['value']"></AssetsTemplatesDropdown>

    <TriggerSceneData
      v-else-if="svar.type === 'scene_data_all'"
      :allVars="vars"
      :index="index"
      :vars="vars[index]['value']"
      :label="vars[index]['name']"
      :hint="vars[index]['hint']" />
  </div>
</template>
<script setup>
import { ref } from 'vue';
import { deluge } from '@/stores/deluge.js';
import ScenePicker from './ScenePicker.vue';
import AssetsTemplatesDropdown from './AssetsTemplatesDropdown.vue';
import TriggerSceneData from './TriggerSceneData.vue';
const sceneSelectorDialog = ref(false);

const props = defineProps(['vars']);
function sceneSelected(scene) {
  sceneSelectorDialog.value = false;
  props.vars[0]['value'] = { name: scene.name, value: scene.uid };
}
function channelsWithNames() {
  // names can be found in deluge.items
  return Object.values(deluge.channels).map((channel) => {
    return {
      ...channel,
      name: deluge.items[channel.did].name,
    };
  });
}
</script>
